<template>
  <el-dialog v-model="show" width="fit-content" align-center destroy-on-close>
    <div class="image-preview">
      <img :src="imageUrl" class="image-box" />
    </div>
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue'

const show = ref(false)
const imageUrl = ref('')

function open(url) {
  imageUrl.value = url
  show.value = true
}

defineExpose({ open })
</script>

<style lang="scss" scoped>
$preview-w: min(1280px, 92vw, calc(85vh * 16 / 9));

.image-preview {
  width: $preview-w;
  max-width: 100%;
  box-sizing: border-box;
}
.image-box {
  display: block;
  width: 100%;
  height: auto;
  max-height: 85vh;
  aspect-ratio: 16 / 9;
  object-fit: contain;
}
</style>
